define([
	"dojo/_base/declare",
	"csi/action",
	"csi/action/Popup",
	"csi/heading/RefContainer",
	"csi/def",
	"csi/heading/Url",
	"csi/html",
	"csi/locale",
	"csi/threeD/utility/ThreeDRotationIcon",
	"csi/xml"
], function(declare,csiAction,Popup,RefContainer,def,Url,html,locale,{create3DRotationIcon},xml) {

	function _getDocumentName(/*Context*/ctx) {
		// summary: return name of Document rather than name of DocumentRevision
		var master = ctx.getNodeParent();
		return master ? master.$Name : null;
	}

	var	_Url = declare(Url, {

		/**
		 * @override
		 * If Document has a file, display a link to the file, if Document has no file, display a link to the Document node or the name of the Document
		 */
		toHtmlStatic: function(ctx, h, refNode, actionData) {
			const value = this._getValue(ctx, h);
			const { view, bExcel, bPopup, bPrint } = ctx;
			const parent = ctx.getNodeParent();
			
			// Show 3D Icon if the document is a 3D document
			if (xml.isValidURL(value) && parent && parent.Is3D && !bPopup && !bExcel && !bPrint) {
				refNode = html.create("div", {
					class: "csi-flex-row",
				}, refNode);
	    
				this.inherited(arguments);	  
				return create3DRotationIcon(view, refNode, value, h, parent);
			}		
			
			if (xml.isValidURL(value)) {
				return this.inherited(arguments);
			}		

			var document = ctx.getNodeParent();
			var anchor = def.createBrowseAnchor(ctx, refNode, document);

			// If the anchor is non-null a link to the Document node is displayed. Otherwise it's just a text display of the Document's name
			html.text(anchor || refNode, document.$Name);

			return true;
		},

		toValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: use Document name rather than file name
			return _getDocumentName(ctx) || locale.getEmptyName();
		},

		_toFilterValue: function(/*Context*/ctx, /*Heading*/h, /*Any*/value) {
			// summary: use Document name rather than file name
			return _getDocumentName(ctx);
		}
	});

	return declare(RefContainer, {
		_getSubHeadingToRender: function(/*Heading*/h) {
			// summary: add renderer class to sub-heading
			var sh = this.inherited(arguments);
			sh.classRenderer = _Url;
			return sh;
		}
	});
});